/**
 * 견적서(Quote) Phase 1a 상수.
 * 서버 계약(zep-school `exhibition`)을 미러링한다.
 * 단가·최소조건·엔드포인트만 정의하는 순수 상수 모듈(스키마 import 금지 — 순환 방지).
 */

export const QUOTE_PLAN_TYPES = ['individual', 'group'] as const;
export type QuotePlanType = (typeof QUOTE_PLAN_TYPES)[number];

export const QUOTE_PLANS = ['basic', 'pro'] as const;
export type QuotePlan = (typeof QUOTE_PLANS)[number];

/** 단가: 1인 1개월 기준 */
export const QUIZ_QUOTE_UNIT_PRICE: Record<QuotePlan, number> = {
  basic: 20_000,
  pro: 50_000,
};
export const QUIZ_GROUP_PRO_UNIT_PRICE = 30_000;

/** 학교·단체(group) 최소 조건 (서버 `QUIZ_GROUP_MIN_USERS/TERM` 미러) */
export const QUIZ_GROUP_MIN_USERS = 5;
export const QUIZ_GROUP_MIN_TERM = 3; // 개월

/** 이용 기간·인원 상한 (Django 폼 미러) */
export const QUIZ_TERM_MAX = 24; // 개월
export const QUIZ_USER_COUNT_MAX = 100;

/** 사용 기간 select 옵션 (1~24개월) */
export const QUIZ_TERM_OPTIONS = Array.from(
  { length: QUIZ_TERM_MAX },
  (_, i) => ({ value: String(i + 1), label: `${i + 1}개월` }),
);

/** 플랜별 기능 리스트 (Figma "플랜 선택" 기능 그리드) */
export interface QuotePlanFeature {
  label: string;
  isAi?: boolean;
}
export const QUIZ_PLAN_FEATURES: Record<QuotePlan, QuotePlanFeature[]> = {
  basic: [
    { label: '베이직 전용 맵 이용' },
    { label: '비공개 퀴즈 만들기' },
    { label: 'AI로 문제 추가하기', isAi: true },
  ],
  pro: [
    { label: '모든 맵 무제한 이용' },
    { label: '학습 리포트(LMS)의 모든 기능' },
    { label: '다음 퀴즈 이어 풀기' },
    { label: '워크시트 저장' },
    { label: 'AI 학습도우미', isAi: true },
    { label: '문제 다국어 번역', isAi: true },
    { label: '유사 문제 만들기', isAi: true },
    { label: '보기·정답 만들기', isAi: true },
  ],
};

/** 프라이싱 진입 세그먼트 → 견적 프리필 (pricingTabQuery 와 값 정의를 맞춤) */
export const QUOTE_SEGMENTS = ['individual', 'group'] as const;
export type QuoteSegment = (typeof QUOTE_SEGMENTS)[number];
export const QUOTE_SEGMENT_QUERY_KEY = 'tab';

export function parseQuoteSegment(value: unknown): QuoteSegment {
  const v = Array.isArray(value) ? value[0] : value;
  return v === 'group' ? 'group' : 'individual';
}
